export const getSearchStringRegExp = str =>
  new RegExp(
    escapeRegExp(str)
      .trim()
      .toLowerCase(),
    'i'
  );

function escapeRegExp(string: string): string {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
